import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faFaceLaughBeam, faFrown, faMeh, faSadTear, faSmile } from "@fortawesome/pro-regular-svg-icons";
import './styles.css';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';
import { HistoricItemProps } from '../../../interfaces/props/SaudeBemEstar/MeuDiario/HistoricItemProps';
import { useNavigate } from 'react-router-dom';

function HistoricItem(props: HistoricItemProps) {
    const accessibility = useAccessibility();
    const navigate = useNavigate(); 

    const getIcon = (icon: string) => {
        switch (icon) {
            case "far fa-sad-tear":
                return faSadTear;
            case "far fa-frown":
                return faFrown;
            case "far fa-meh":
                return faMeh;
            case "far fa-smile":
                return faSmile;
            case "far fa-laugh-beam":
                return faFaceLaughBeam;
            case "fas fa-check":
                return faCheck;
            default:
                return faSadTear;
        }
    }

    const getStatusName = (icon: string) => {
        switch (icon) {
            case "far fa-sad-tear":
                return 'muito mal';
            case "far fa-frown":
                return 'mal';
            case "far fa-meh":
                return 'mais ou menos';
            case "far fa-smile":
                return 'bem';
            case "far fa-laugh-beam":
                return 'muito bem';
            case "fas fa-check":
                return 'check';
            default:
                return 'muito mal';
        }
    }

    return (
        <button 
            className={`${accessibility.contrastMode ? 'historic-item-holder-contrast' : 'historic-item-holder' }`} 
            onClick={() => {navigate(`/saudeBemEstar/unimedAcolhe/meuDiario/registro/${props.historicItem.id_resp_quest_benef}`)}}
            aria-label={`Ver registro de status ${getStatusName(props.historicItem.iconface)} em ${props.historicItem.data} às ${props.historicItem.hora}`}
        >
            <div className="historic-item-icon">
                <FontAwesomeIcon icon={getIcon(props.historicItem.iconface)} style={accessibility.contrastColorAccessibility} size="2x"/>
            </div>
            <div className="historic-item-info">
                <span className='historic-item-data' style={accessibility.textStyleAccessibility}>{props.historicItem.data}</span>
                <span className='historic-item-hour' style={accessibility.textStyleAccessibility}>{props.historicItem.hora}</span>
            </div>
        </button>
    )
}

export default HistoricItem;